<template>
  <div>
    轮播图编辑新增
    <div class="input-wrap">
      <label>标题</label>
      <el-input
        type="text"
        v-model="info.title"
        placeholder="请输入标题"
        class="sort_input"
      ></el-input>
    </div>
    <div class="input-wrap">
      <label>权重</label>
      <el-input
        type="number"
        v-model="info.sort"
        placeholder="0～99,越大越靠前"
        class="sort_input"
      ></el-input>
    </div>
    <div class="input-wrap">
      <label>跳转链接</label>
      <el-input
        type="text"
        v-model="info.carousel_url"
        placeholder="请输入跳转链接"
        class="sort_input"
      ></el-input>
    </div>
    <div class="img-wrap">
      <label>图片</label>
      <div class="m-upload">
        <imageUpload v-model="carousel_img" :limit="1" />
        <p>pc端图片(尺寸: 1920*760)</p>
      </div>
      <div class="m-upload">
        <imageUpload v-model="h5_carousel_img" :limit="1" />
        <p>h5端图片(尺寸: 750*880)</p>
      </div>
    </div>
    <div class="btn-wrap">
      <el-button type="primary" class="confirmBtn" @click="confirmClick"
        >保存</el-button
      >
      <el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import imageUpload from "@/components/ImageUpload";
import {
  addCarousel,
  carouselDetail,
  editCarousel,
} from "@/api/carousel-manage";

export default {
  name: "messagepush",
  data() {
    return {
      info: {
        sort: "",
        carousel_img: "",
        title: "",
        carousel_url: "",
      },
      carousel_img: [],
      h5_carousel_img: [],
      type: "add",
    };
  },
  components: {
    imageUpload,
  },
  mounted() {
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this.getCarouselDetail(uuid);
      this.type = "edit";
    }
    // this.init();
  },
  methods: {
    async confirmClick() {
      this.info.carousel_img = this.carousel_img.join("");
      this.info.h5_carousel_img = this.h5_carousel_img.join("");
      const { title, sort, carousel_img, h5_carousel_img, carousel_url } = this.info;
      if (!title) {
        this.$message("标题不能为空");
        return;
      }
      if (!sort) {
        this.$message("排序序号不能为空");
        return;
      }
      if (+sort < 0 || +sort > 99 || sort % 1 !== 0) {
        this.$message("排序序号必须为0～99之间的整数");
        return;
      }
      if (!carousel_url) {
        this.$message("请输入跳转链接");
        return;
      }
      if (!carousel_img) {
        this.$message("请上传pc端图片");
        return;
      }
      if (!h5_carousel_img) {
        this.$message("请上传h5端图片");
        return;
      }
      if (this.type === "add") {
        const { status } = await addCarousel(this.info);
        if (status === 200) this.$router.go(-1);
      } else if (this.type === "edit") {
        const { status } = await editCarousel(this.info);
        if (status === 200) this.$router.go(-1);
      }
    },
    cancelClick() {
      this.$router.go(-1);
    },
    async getCarouselDetail(uuid) {
      const { status, data } = await carouselDetail(uuid);
      if (status !== 200) return;
      this.info = data;
      this.carousel_img = [data.carousel_img];
      this.h5_carousel_img = [data.h5_carousel_img];
    },
    //     init() {
    // this.$nextTick(()=>{
    // console.log(this.formData.content)
    //  this.$refs.froalaEditor.setHtml(this.formData.content)
    // })
    // },
    // changeContent (html) {
    //  this.formData.content = html
    //  console.log(html, 'html')
    // },
  },
};
</script>

<style lang="less" scoped>
.input-wrap {
  margin-top: 30px;
  .sort_input {
    width: 300px;
  }
}
label {
  display: block;
  margin-bottom: 10px;
}
.img-wrap {
  margin-top: 30px;
}
.btn-wrap {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  .confirmBtn {
    margin-right: 50px;
  }
}
.m-upload {
  p {
    font-size: 12px;
    margin-top: 10px;
    padding-left: 60px;
  }
}
</style>
